module.exports = __webpack_public_path__ + "img/eres.3aca5bb1.png";